import { render, staticRenderFns } from "./TreesTwo.vue?vue&type=template&id=381fbd76&scoped=true"
var script = {}
import style0 from "./TreesTwo.vue?vue&type=style&index=0&id=381fbd76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381fbd76",
  null
  
)

export default component.exports